module.exports = require('./helpers/bundle-url').getBundleURL('gA8FI') + "testimonial-david-bellaiche-mobile.c3669d3d.webp";